import type { ChartColorRef } from './types'

/** Cash-flow Sankey node definitions (Unit Overview). Colors are theme keys. */
export const cashflowSankeyNodes = [
  { id: 0, label: 'Opening Balance', color: 'primary' },
  { id: 1, label: 'Rental Income', color: 'success' },
  { id: 2, label: 'Other Income', color: 'success' },
  { id: 3, label: 'Cash Deposits', color: 'success' },
  { id: 4, label: 'Real Estate Assets', color: 'quaternary' },
  { id: 5, label: 'Operating Expenses', color: 'error' },
  { id: 6, label: 'Investing Activities (Capex)', color: 'tertiary' },
  { id: 7, label: 'Financing Outflows', color: 'error' },
  { id: 8, label: 'Closing Balance', color: 'primary' },
] as const satisfies ReadonlyArray<{ id: number; label: string; color: ChartColorRef }>

export const sankeyChartConfig = {
  orientation: 'h' as const,

  node: {
    pad: 15,
    thickness: 20,
    lineWidth: 1,
  },

  link: {
    /** Opacity for links derived from source node color. */
    opacity: 0.4,
  },

  defaultNodeColors: [
    'primary',
    'secondary',
    'tertiary',
    'quaternary',
    'success',
    'warning',
    'error',
    'info',
  ] as ChartColorRef[],

  colors: {
    title: 'textSecondary' as ChartColorRef,
    text: 'text' as ChartColorRef,
    nodeBorder: 'border' as ChartColorRef,
    errorText: 'error' as ChartColorRef,
  },

  layout: {
    margins: { withTitle: { t: 35, r: 20, b: 20, l: 20 }, withoutTitle: { t: 5, r: 20, b: 20, l: 20 } },
  },

  defaults: {
    height: '100%' as const,
    width: '100%' as const,
  },

  emptyMessage: 'No data available',
} as const
